import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {StoreSelectorsService} from "../../../../services";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";

@Component({
    selector: 'app-scene-block-stepper',
    templateUrl: './block-stepper.component.html',
    styleUrls: ['./block-stepper.component.scss']
})
export class BlockStepperComponent extends BlockBaseComponent {

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        return super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
    }

    // minimum: string;
    // maximum: string;
    // step: string;
    // softKeyboard: string;

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.minimum', {}, this.translocoService.getActiveLang()),
                inputType: "number",
                min: 0,
                step: 1,
                name: "minimum",
                storePath: 'Data[0].Stepper[0].$.minimum'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.maximum', {}, this.translocoService.getActiveLang()),
                inputType: "number",
                min: 0,
                step: 1,
                name: "maximum",
                storePath: 'Data[0].Stepper[0].$.maximum'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.step', {}, this.translocoService.getActiveLang()),
                inputType: "number",
                min: 0,
                step: 0.01,
                name: "step",
                storePath: 'Data[0].Stepper[0].$.step'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.defaultValue', {}, this.translocoService.getActiveLang()),
                inputType: "number",
                min: 0,
                step: 1,
                name: "defaultValue",
                storePath: 'Data[0].Stepper[0].$.defaultValue'
            },
            {
                type: "input",
                value: '',                                        
                label: this.translocoService.translate('general.softKeyboard', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "softKeyboard",
                storePath: 'Data[0].Stepper[0].$.softKeyboard'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.fieldName', {}, this.translocoService.getActiveLang()),
                name: "fieldName",
                inputType: "text",
                storePath: 'Data[0].Stepper[0].$.fieldName'
            }
        ];
    }
}

